<template>
  <div>
    <div class="columns is-multiline is-centered"> <!-- quitar y dejar el div solito(?) -->
      <div class="column is-12 has-text-centered">
        <users-list
          :users="users"
          :pagination="pagination"
          :getUsers="getUsersList"
          :roles="roles"
          :role="role"
          :emailUser="emailUser"
          :loading="isLoading"
        />
      </div>
    </div>
    <modal-component
      :active="isModalOpen"
      @cancel="cancel"
      :titleModal="'Nuevo usuario'"
      optionalText="Completa los datos para crear un nuevo usuario en la plataforma."
      @hdlOnClick="addNewUser"
      :loading="isSent"
      :loader="isSent"
    >
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="field">
            <label class="label">Nombre</label>
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="Nombre"
                v-model="name"
                name="name"
                v-validate="'required'"
                :class="{'is-danger': vverrors.has('name')}"
              >
            </div>
          </div>
          <div class="field">
            <label class="label">Apellido</label>
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="Apellido"
                v-model="lastName"
                name="lastName"
                v-validate="'required'"
                :class="{'is-danger': vverrors.has('lastName')}"
              >
            </div>
          </div>
          <div class="field">
            <label class="label">Rol</label>
            <div class="select is-fullwidth" :class="{'is-danger': vverrors.has('roleId')}">
              <select
                class="select"
                v-model="roleId"
                name="roleId"
                v-validate="'required'"
              >
                <option value="" selected disabled> Selecciona un rol </option>
                <option  v-for="role in roles" :value="role.id" :key="role.id"> {{getRoleName(role)}} </option>
              </select>
            </div>
          </div>
          <div class="field">
            <label class="label">Correo Electrónico</label>
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="Correo Electrónico"
                v-model="email"
                name="email"
                autocomplete="false"
                v-validate="'required|email'"
                :class="{'is-danger': vverrors.has('email')}"
              >
            </div>
          </div>
          <div class="field">
            <div class="user-notice">
              <i class="fas fa-info-circle user-notice__icon"></i>
              <span>La contraseña será enviada directamente al correo electrónico del usuario que estás registrando.</span>
            </div>
          </div>
        </div>
      </div>
    </modal-component>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '@/mixins/formats'

export default {
  name: 'Users',
  mixins: [mixins],
  components: {
    UsersList: () => import('@/components/Users/UsersList.vue'),
    ModalComponent: () => import('@/components/ui/ModalComponent')
  },
  props: {
    usersSearch: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      users: [],
      pagination: {},
      roles: [],
      isModalOpen: false,
      name: '',
      lastName: '',
      roleId: '',
      email: '',
      isSent: false,
      isLoading: false,
      user: {},
      financialCompany: {},
      emailUser: '',
      selectedOption: 'users',
      enableAddUsers: false
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: (state) => state.financialCompany.financialCompany,
      roleCode: state => state.financialCompany?.role?.code || '',
      role: state => state.financialCompany?.role || ''
    }),
    hasUserAddAccess () {
      const adminRoles = ['admin', 'manager', 'compliance']
      return adminRoles.includes(this.roleCode) || this.enableAddUsers
    }
  },
  mounted () {
    this.emitTitleAction()
    const data = {
      pageNumber: 0,
      perPage: 10,
      search: this.usersSearch || ''
    }
    const rolesPagination = {
      pageNumber: 0,
      perPage: 20
    }
    this.isLoading = true
    this.getUsers(data).then(({ users, pagination }) => {
      this.users = users
      this.pagination = pagination
      this.isLoading = false
    })
    this.getRoles(rolesPagination)
      .then(({ roles }) => {
        this.roles = roles
      })
    if (this.roleCode === 'custom') {
      this.hasCustomRoleAccess()
    }
  },
  methods: {
    ...mapActions(['getUsers', 'addUser', 'getRoles', 'profileMe', 'getServicePermission']),
    emitTitleAction () {
      this.$emit('update-title-action', {
        label: 'Nuevo usuario',
        visible: this.hasUserAddAccess,
        disabled: false,
        handler: this.openCreateModal
      })
    },
    openCreateModal () {
      if (this.hasUserAddAccess) {
        this.isModalOpen = true
      }
    },
    getUsersList (page) {
      this.isLoading = true
      this.getUsers({ pageNumber: page, perPage: 10, search: this.usersSearch || '' })
        .then(({ users, pagination }) => {
          this.users = users
          this.pagination = pagination
          this.isLoading = false
        })
    },
    async addNewUser () {
      if (await this.$validator.validateAll()) {
        this.isSent = true
        const data = {
          name: this.name,
          lastName: this.lastName,
          roleId: parseFloat(this.roleId),
          email: this.email,
          password: '',
          autoGeneratePassword: true
        }
        const userId = await this.addUser(data)
        if (userId && userId.success) {
          this.name = ''
          this.lastName = ''
          this.roleId = ''
          this.email = ''
          this.isModalOpen = false
          await this.getUsersList(0)
        }
        this.isSent = false
      }
    },
    cancel () {
      this.isModalOpen = false
      this.name = ''
      this.lastName = ''
      this.roleId = ''
      this.email = ''
    },
    optionActive () {
      this.selectedOption = this.$route.name
    },
    async hasCustomRoleAccess () {
      const resp = await this.getServicePermission(['saveUser'])
      const filter = resp.filter(service => service.enabled).map(service => service.code)
      this.enableAddUsers = filter.includes('saveUser')
      this.emitTitleAction()
    }
  },
  watch: {
    usersSearch () {
      this.getUsersList(0)
    },
    roleCode (newValue) {
      if (newValue === 'custom') {
        this.hasCustomRoleAccess()
      } else {
        this.enableAddUsers = false
        this.emitTitleAction()
      }
    },
    hasUserAddAccess () {
      this.emitTitleAction()
    }
  },
  created () {
    this.emitTitleAction()
  }
}
</script>

<style lang="scss" scoped>
a.icon {
  cursor: pointer;
  pointer-events: auto !important;
  z-index: 9999;
}
.field input {
  font-size: 0.75rem;
  padding: 1.20rem 0.5rem;
}

.user-notice {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #edf1ff;
  border: 1px solid #c5d0ff;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 500;
  color: #283056;
  line-height: 1.5;

  &__icon {
    color: #4c70ff;
    font-size: 13px;
    margin-top: 1px;
    flex-shrink: 0;
  }
}
</style>
